export default __webpack_public_path__ + "static/signal_sounds-0dba1c2363dc4be267774dedfcf091e3.png";